"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Message;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Card_1 = __importDefault(require("../components/Card"));
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        button: {
            alignItems: 'center',
            backgroundColor: THEME.CardBackground,
            borderColor: THEME.CardBorder,
            borderWidth: 1,
            borderBottomWidth: 2,
            borderRadius: 4,
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            padding: 10,
            userSelect: 'none'
        },
        importantButton: {
            alignItems: 'center',
            backgroundColor: THEME.Red + 'CC',
            borderRadius: 4,
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            padding: 10,
            userSelect: 'none'
        },
        importantAfterActionButton: {
            alignItems: 'center',
            backgroundColor: THEME.Secondary,
            borderRadius: 4,
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            padding: 10,
            userSelect: 'none'
        }
    });
};
function Message(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [actionLoading, setActionLoading] = react_1.default.useState(false);
    let indicatorColor = THEME.Primary;
    switch (props.indicator) {
        case "secondary":
            indicatorColor = THEME.Secondary;
            break;
        case "warning":
            indicatorColor = THEME.Warning;
            break;
        case "error":
            indicatorColor = THEME.Red;
            break;
        default:
            indicatorColor = THEME.Primary;
            break;
    }
    const action = async () => {
        if (!props.onActionStart)
            return;
        if (props.onActionComplete)
            setActionLoading(true);
        props.onActionStart()?.then((data) => {
            if (props.onActionComplete)
                props.onActionComplete(data);
            setActionLoading(false);
        }).catch((data) => {
            if (props.onActionError)
                props.onActionError(data);
            setActionLoading(false);
        });
    };
    return ((0, jsx_runtime_1.jsx)(Card_1.default, { style: {
            backgroundColor: 'transparent',
            borderWidth: 0,
            borderBottomWidth: 0,
            padding: 0,
            marginTop: 12
        }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: !props.onActionStart, accessible: true, onPress: action, style: ({ pressed }) => [
                    (props.important ? props.degrade ? styles.importantAfterActionButton : styles.importantButton : styles.button),
                    { minHeight: 44, alignItems: 'stretch' },
                    (pressed ? (props.important ? props.degrade ? { backgroundColor: THEME.Secondary + '99' } : { backgroundColor: THEME.Red + 'AA' } : STYLES.pressed) : null)
                ], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, flexDirection: 'row', alignItems: 'center' }, children: [(props.indicator == 'none' || props.important) ||
                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                    width: 4,
                                    alignSelf: 'stretch',
                                    backgroundColor: indicatorColor,
                                    borderRadius: 4
                                } }), props.imageLeft, (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: props.content }), props.imageRight, !!props.actionText &&
                            (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                    marginLeft: 8,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: size != 'sm' && !props.important ? THEME.Primary : 'transparent',
                                    paddingVertical: 6,
                                    paddingHorizontal: 12,
                                    borderRadius: 3
                                }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: size != 'sm' ? THEME.White : (props.important ? THEME.White : THEME.Primary), fontSize: 16, fontWeight: '500', opacity: actionLoading ? 0 : 1 }, children: props.actionText }), actionLoading &&
                                        (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: size != 'sm' ? THEME.White : THEME.Primary, size: "small", style: { position: 'absolute', height: 8 } })] })] }) }) }) }));
}
